import React from 'react';
import { Route, Switch } from 'react-router-dom';

import NotFoundPage from 'app/components/NotFoundPage';

import MainLayout from 'app/components/layouts/MainLayout';
import BorrowingLayout from 'app/components/borrowing/shared/BorrowingLayout';
import AuthenticatedRoute from 'app/routes/AuthenticatedRoute';
import AccountRequiredRoute from 'app/routes/AccountRequiredRoute';
import FinesPayPageRoute from './pay/FinesPayPageRoute';
import FinesPageRoute from './FinesPageRoute';

const basePath = '/v2/fines';

export default (
  <Route path={basePath}>
    <AuthenticatedRoute>
      <AccountRequiredRoute>
        <Switch>
          <Route exact path={basePath}>
            <MainLayout deprecated>
              <BorrowingLayout>
                <FinesPageRoute />
              </BorrowingLayout>
            </MainLayout>
          </Route>
          <Route path={`${basePath}/pay`}>
            <MainLayout>
              <FinesPayPageRoute />
            </MainLayout>
          </Route>
          <Route>
            <MainLayout>
              <NotFoundPage />
            </MainLayout>
          </Route>
        </Switch>
      </AccountRequiredRoute>
    </AuthenticatedRoute>
  </Route>
);
